import React from "react";

// Table loading placeholder for the My Inventory tabs (Prospects + MLS).
const InventoryTableSkeleton = ({ rows = 5 }) => (
  <div className="inventory-table-skeleton">
    {Array.from({ length: rows }).map((_, i) => (
      <div className="inventory-table-skeleton__row" key={i}>
        <div className="inventory-table-skeleton__img shimmer" />
        <div className="inventory-table-skeleton__lines">
          <div className="inventory-table-skeleton__line shimmer" style={{ width: "70%" }} />
          <div className="inventory-table-skeleton__line shimmer" style={{ width: "40%" }} />
        </div>
        <div className="inventory-table-skeleton__pill shimmer" />
        <div className="inventory-table-skeleton__cell shimmer" />
      </div>
    ))}
  </div>
);

export default InventoryTableSkeleton;
